/* eslint-disable */
export enum FinnairGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  UNSPECIFIED = 'UNSPECIFIED',
  UNKNOWN = 'UNKNOWN'
}

